import {PriceLine, PriceRider} from "../../../../../api/Pricing";
import {QuotePriceLine, QuotePriceRider} from "../../../../../api/QuotePricing";
import {woodDoor} from "../../openings/Const";
import {QuotePDFBuilder} from "./QuotePDFBuilder";
import {PriceSectionNote} from "../../../../../api/PriceSectionNotes";

const isWoodDoor = (input: PriceLine|QuotePriceLine) => input.productType === "door" && input.door.series === woodDoor;
const isWoodDoorRider = (input: PriceRider|QuotePriceRider) => input.productType === "door" && (input.sectionKey === "door-wd" || input.sectionKey === "door-riders/wd");
const isWoodDoorPrep = (input: PriceLine|QuotePriceLine) => input.productType === "door-prep" && input.doorSeries === woodDoor;
const isWoodDoorPrepRider = (input: PriceRider|QuotePriceRider) => input.productType === "door-prep" && input.sectionKey === "door-prep/wd";

export function addWoodDoors(bld: QuotePDFBuilder, props: {
    prices: (PriceLine|QuotePriceLine)[];
    riders: (PriceRider|QuotePriceRider)[];
    notes: PriceSectionNote[]
}) {
    const wdPrices = props.prices.filter(i =>
        isWoodDoor(i) ||
        isWoodDoorPrep(i)
    );

    const wdRiders = props.riders.filter(r => isWoodDoorRider(r) || isWoodDoorPrepRider(r));
    if(wdPrices.length > 0) {
        bld.addSection(
            {
                title: "Wood Doors",
                note: props.notes.filter(n => n.keyName === "door-wd" || n.keyName === "door/wd").map(n => n.note),
                categories: [{
                    name: "Door",
                    filter: isWoodDoor,
                    filterRider: isWoodDoorRider,
                    adminExcludeRiders: true,
                }, {
                    name: "Door Preps",
                    filter: isWoodDoorPrep,
                    filterRider: isWoodDoorPrepRider,
                    adminExcludeRiders: true,
                }, !bld.excludeRiders && {
                    name: "Door Riders",
                    filter: () => false,
                    filterRider: (i: PriceRider | QuotePriceRider) => isWoodDoorRider(i) || isWoodDoorPrepRider(i),
                }],
            },
            (wdPrices as PriceLine[] | QuotePriceLine[]), wdRiders);
    }
}